"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("stremio/core");
var common_1 = require("stremio/common");
var useRouteFocused_1 = require("stremio/common/useRouteFocused");
var EPG_1 = require("stremio/common/EPG");
var MODEL = 'live_tv_continue_watching';
var useLiveTvContinueWatching = function () {
    var core = (0, core_1.useCore)();
    var active = (0, useRouteFocused_1.useRouteActive)();
    var state = (0, common_1.useModelState)({ model: MODEL, action: null });
    (0, EPG_1.useLiveRefresh)('LiveTvContinueWatching', MODEL, active);
    react_1.default.useEffect(function () {
        core.transport.dispatch(active ? {
            action: 'Load', args: { model: 'LiveTvContinueWatching' },
        } : { action: 'Unload' }, MODEL);
    }, [active, core.transport]);
    return state;
};
exports.default = useLiveTvContinueWatching;
